import PhotoMotion from '@/components/feature/PhotoMotion';
import { cdn } from '@/config/cdn';

export default function Philosophy() {
  return (
    <section className="bg-[#F5F1EB] text-[#171515] py-20 md:py-32" aria-labelledby="philosophy-heading">
      <div className="fold-shell">
        <p className="fold-label text-[#8A8580]">02 — Philosophy</p>
        <h2 id="philosophy-heading" className="mt-8 md:mt-12 fold-serif uppercase leading-[0.9] tracking-[-0.03em] text-[13vw] sm:text-[10vw] lg:text-[8vw] xl:text-[8.4rem]">
          Good things<br /><span className="italic pl-[8vw] lg:pl-[14vw]">take layers.</span>
        </h2>

        <div className="mt-14 md:mt-24 grid grid-cols-1 md:grid-cols-12 gap-y-10 md:gap-x-8 items-end">
          <div className="md:col-span-5 lg:col-span-4 min-w-0">
            <div className="w-full aspect-[4/5] overflow-hidden bg-[#e4e0da]">
              <PhotoMotion fromScale={1.04} fromY={16} duration={1.2}>
              <img
                src={cdn('https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_story-philosophy.webp')}
                alt="Cross-section of a croissant showing its laminated layers"
                title="Laminated layers — FOLD. Artisan Bakery"
                className="w-full h-full object-cover object-center"
              />
              </PhotoMotion>
            </div>
          </div>
          <div className="md:col-span-6 md:col-start-7 lg:col-span-4 lg:col-start-8 min-w-0">
            <p className="fold-serif text-[22px] md:text-[26px] leading-snug">We believe the smallest details make the biggest difference.</p>
            <p className="mt-6 text-[15px] md:text-base leading-[1.75] text-[#5d5853] max-w-[420px]">
              The fold of the dough. The time between each rise. The care taken before anything reaches the oven.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}